import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// tailwind-merge must know the token utilities tokens.css adds, or it would treat them as
// unrelated (or as the wrong group) and keep two conflicting classes.
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: ["2xs", "md"],
      "font-weight": ["ui", "title", "strong"],
      tracking: ["title", "heading", "caps", "eyebrow"],
      shadow: ["primary"],
    },
    classGroups: {
      "border-color": ["border-subtle", "border-strong"],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
